import { render, staticRenderFns } from "./TransactionSuccessToast.vue?vue&type=template&id=da8a663e"
import script from "./TransactionSuccessToast.vue?vue&type=script&lang=js"
export * from "./TransactionSuccessToast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
